export enum RequestInitiatorTypeV2 {
  HCP = 'HCP',
  RPM_EVENT = 'RPM_EVENT',
}
